<template>
  <b-card class="no-border animated">
    <div class="item-header clearfix mb-3">
      <h5 class="pull-left mb-0 mt-2">{{ header }}</h5>
    </div>
    <b-form @submit.prevent="onSubmit()">
      <legend>Vehicle Detail</legend>
      <div class="form-row">
        <div class="form-group col-md-12">
          <label for="input_reg_number">Reg Number</label>
          <input
            name="reg number"
            id="input_reg_number"
            type="text"
            class="form-control"
            v-validate="'required'"
            v-model.trim="form.reg_no"
            :class="{'is-invalid': errors.has('reg number')}"
            placeholder="Enter Reg Number">
          <b-form-feedback>{{ errors.first('reg number') }}</b-form-feedback>
        </div>

      </div>
      <div class="form-row" >
        <div class="form-group col-md-6" v-if="!isEdit">
          <legend v-if="!isEdit">Company</legend>
          <label>Company</label>
            <company-multi-select
              :multiple="false"
              type="TRANSPORTER"
              :init-selection-id="vehicleCompanyId"
              @on-selected="onCompanySelected"
              required
            />
        </div>
        <div class="form-group col-md-6" v-if="isPrambananConfig">
          <legend v-if="isPrambananConfig">Storage</legend>
          <label for="storage_type">Storage Type</label>
            <b-form-select
              name="storage type"
              id="storage_type"
              v-validate="'required'"
              v-model="form.metadata.storage_type"
              :options="storageTypeOptions"
              :class="{'is-invalid': errors.has('storage type')}">
            </b-form-select>
          <b-form-feedback>{{ errors.first('storage type') }}</b-form-feedback>
        </div>
      </div>
      <div class="form-row" v-if="isPrambananConfig">
        <div class="form-group col-md-12">
          <div class="item-header item-header-no-border-bottom clearfix mb-3">
            <p class="pull-left mb-0 mt-2">Working Area</p>
            <div class="pull-right">
              <b-button variant="outline-primary" @click="addRows()"><i class="fa fa-plus"></i>&nbsp; Add new working area</b-button>
            </div>
          </div>
          <table>
            <tbody>
              <tr v-for="dt in working_area" :key="dt.key">
                <td v-if="dt.show">
                  <input
                    v-model="dt.value"
                    @change="handleChangeWorkingArea(dt)"
                    type="text"
                    class="form-control"
                    :placeholder="`Working Area`">
                </td>
                <td v-if="dt.show">
                  <b-button variant="outline-danger" @click="removeElement(dt.key)">
                    <i class="fa fa-remove"></i>&nbsp; Delete
                  </b-button>
                </td>
              </tr>
              <tr v-for="dt in metaNew" :key="`new-${dt.key}`">
                <td>
                  <input
                    v-model="dt.value"
                    type="text"
                    class="form-control"
                    :placeholder="`Working Area`">
                </td>
                <td>
                  <b-button variant="outline-danger" @click="removeElement(dt.key, true)">
                    <i class="fa fa-remove"></i>&nbsp; Delete
                  </b-button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="form-group col-md-12">
          <b-form-checkbox
            id="standby"
            v-model="isStandby"
            name="standby"
          >
            Standby
          </b-form-checkbox>
        </div>
        <div class="form-group col-md-12">
          <b-form-checkbox
            id="cdd"
            v-model="isCDD"
            name="cdd"
          >
            Colt Diesel Double (CDD)
          </b-form-checkbox>
        </div>
        <div class="form-group col-md-6">
          <div class="item-header item-header-no-border-bottom clearfix mb-3">
            <p class="pull-left mb-0 mt-2">Fleet Equipment</p>
            <div class="pull-right">
              <b-button variant="outline-primary" @click="addFleetEquipment()"><i class="fa fa-plus"></i>&nbsp; Add new fleet equipment</b-button>
            </div>
          </div>
          <p v-if="noFleetEquipment" class="text-center">There's No Fleet Equipment Data</p>
          <table v-else>
            <tbody>
              <tr v-for="fe in fleet_equipment" :key="fe.key">
                <td v-if="fe.show">
                  <input
                    v-model="fe.value"
                    @change="handleChangeFleetEquipment(fe)"
                    type="text"
                    class="form-control"
                    :placeholder="`Fleet Equipment`">
                </td>
                <td v-if="fe.show">
                  <b-button variant="outline-danger" @click="removeFleetEquipment(fe.key)">
                    <i class="fa fa-remove"></i>&nbsp; Delete
                  </b-button>
                </td>
              </tr>
              <tr v-for="fe in newFleetEquipment" :key="`new-${fe.key}`">
                <td>
                  <input
                    v-model="fe.value"
                    type="text"
                    class="form-control"
                    :placeholder="`Fleet Equipment`">
                </td>
                <td>
                  <b-button variant="outline-danger" @click="removeFleetEquipment(fe.key, true)">
                    <i class="fa fa-remove"></i>&nbsp; Delete
                  </b-button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="form-group col-md-6">
          <div class="item-header item-header-no-border-bottom clearfix mb-3">
            <p class="pull-left mb-0 mt-2">Document</p>
            <div class="pull-right">
              <b-button variant="outline-primary" @click="addDocument()"><i class="fa fa-plus"></i>&nbsp; Add new document</b-button>
            </div>
          </div>
          <p v-if="noDocument" class="text-center">There's No Document Data</p>
          <table v-else>
            <thead>
              <tr>
                <th>Item</th>
                <th>Expired Date</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="d in document" :key="d.key">
                <td v-if="d.show">
                  <input
                    v-model="d.item"
                    @change="handleChangeDocument(d)"
                    type="text"
                    class="form-control"
                    :placeholder="`Item`">
                </td>
                <td v-if="d.show">
                  <input
                    v-model="d.date"
                    @change="handleChangeDocument(d)"
                    type="text"
                    class="form-control"
                    :placeholder="`Expired Date`">
                </td>
                <td v-if="d.show">
                  <b-button variant="outline-danger" @click="removeDocument(d.key)">
                    <i class="fa fa-remove"></i>&nbsp; Delete
                  </b-button>
                </td>
              </tr>
              <tr v-for="d in newDocument" :key="`new-${d.key}`">
                <td>
                  <input
                    v-model="d.item"
                    type="text"
                    class="form-control"
                    :placeholder="`Item`">
                </td>
                <td>
                  <input
                    v-model="d.date"
                    type="date"
                    class="form-control"
                    :placeholder="`Expired Date`">
                </td>
                <td>
                  <b-button variant="outline-danger" @click="removeDocument(d.key, true)">
                    <i class="fa fa-remove"></i>&nbsp; Delete
                  </b-button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <hr>
      <b-button
        type="submit"
        id="createBtn"
        :disabled="disabled"
        variant="primary">
        <span v-if="beforeClick">Save changes</span>
        <span v-else> Loading..</span>
        <i v-if="loadingSpinner" class="fa fa-spinner fa-spin"></i>
      </b-button>
      <b-button
        @click="onCancel()"
        type="reset"
        variant="outline-secondary"
        class="pull-right">Cancel</b-button>
    </b-form>
  </b-card>
</template>
<script>
/* eslint-disable */
import Multiselect from 'vue-multiselect';
import CompanyMultiSelect from '@/components/CompanyMultiSelect.vue';
import { isEmpty, isObject, get } from 'lodash';
import userMixin from './../../../../mixins/user';

export default {
  components: {
    Multiselect,
    CompanyMultiSelect,
  },
  name: 'vehicle_detail',
  mixins: [userMixin],
  data() {
    return {
      form: {
        id: null,
        reg_no: '',
        company: null,
        external_id: '',
        metadata: {
          storage_type: null,
          working_area: [],
          fleet_equipment: [],
          document: [],
          cdd: false,
          standby: false,
        },
      },
      loadingSpinner: false,
      beforeClick: true,
      disabled: false,
      storageTypeOptions: [
        { value: null, text: 'Please select storage type' },
        { value: 'CDE Chiller', text: 'CDE Chiller' },
        { value: 'CDE Chiller Combine', text: 'CDE Chiller Combine' },
        { value: 'CDE Dry', text: 'CDE Dry' },
        { value: 'L300 Dry', text: 'L300 Dry' },
        { value: 'CDD Dry', text: 'CDD Dry' },
      ],
      metaNew: [],
      oldToRemove: [],
      isStandby: false,
      isCDD: false,
      newFleetEquipment: [],
      removedFleetEquipment: [],
      newDocument: [],
      removedDocument: [],
    };
  },
  created() {
    const { vehicleId } = this.$route.params;
    const breadcrumb = [
      { to: '', name: 'Home' },
      { to: 'admin', name: 'Admin' },
      { to: 'vehicles', name: 'Vehicles' },
      { to: vehicleId, name: 'Detail' },
      { to: 'edit', name: 'Edit' },
    ];

    if (!this.isEdit) {
      breadcrumb.splice(3, 2);
      breadcrumb.push({ to: 'create', name: 'Create' });
    } else {
      this.$store.commit('vehicles/SET_DETAIL_ID', vehicleId);
      this.$store.dispatch('vehicles/LOAD_DETAIL_DATA');
    }
    this.$store.commit('SET_BREADCRUMB_ITEMS', breadcrumb);
  },
  computed: {
    detailedInfo() {
      const detailInfo = this.isEdit ? this.$store.getters['vehicles/get_detail_data'] : {};
      return detailInfo;
    },
    vehicleCompanyId() {
      if (this.isEdit) {
        return get(this.detailedInfo, 'company.id', '');
      }
      return this.userData.company_id.toString();
    },
    displayName() {
      return this.detailedInfo.reg_no;
    },
    header() {
      const header = this.isEdit
        ? `Edit Vehicle: ${this.displayName}`
        : 'Create New Vehicle';
      return header;
    },
    userData() {
      return this.$store.getters.userData;
    },
    isSystemAdmin() {
      const { userData } = this.$store.getters;
      return userData.type === 'SYSTEM_ADMIN';
    },
    isEdit() {
      return !isEmpty(this.$route.params.vehicleId);
    },
    isAddFromSelectedCompany() {
      return !isEmpty(this.$route.params.companyId);
    },
    working_area() {
      let areas = [];
      const { metadata } = this.detailedInfo;
      if (metadata) {
        if (metadata.hasOwnProperty('working_area')) {
          metadata.working_area.forEach((area, index) => {
            const dataArea = {
              key: index,
              value: area,
              show: false,
            };
            if (this.oldToRemove.includes(area) == false) dataArea.show = true;
            areas.push(dataArea);
          });
        }
      }
      return areas;
    },
    fleet_equipment() {
      let equipments = get(this.detailedInfo, 'metadata.fleet_equipment', []);

      try {
        equipments = JSON.parse(equipments);
      } catch(e) {}

      equipments = equipments.map((equipment, index) => {
          const options = {
            key: index,
            value: equipment,
            show: true
          };
          const isRemoved = this.removedFleetEquipment.find(
            e => e.toString().toLowerCase() === equipment.toString().toLowerCase())
          if (isRemoved) options.show = false;
          return options;
        }
      )
      return equipments;
    },
    noFleetEquipment() {
      const noFleetEquipment = this.fleet_equipment.filter(fe => fe.show).length === 0;
      const noNewFleetEquipment = this.newFleetEquipment.length === 0;
      return noFleetEquipment && noNewFleetEquipment;
    },
    document() {
      let documents = get(this.detailedInfo, 'metadata.document', []);

      try {
        documents = JSON.parse(documents);
      } catch(e) {}

      documents = documents.map((document, index) => {
        const options = {
          key: index,
          item: document[0],
          date: document[1],
          show: true
        };
        const isRemoved = this.removedDocument.find(
          e => e.item.toString().toLowerCase() === document[0].toString().toLowerCase())
        if (isRemoved) options.show = false;
        return options;
      })
      return documents;
    },
    noDocument() {
      const noDocument = this.document.filter(d => d.show).length === 0;
      const noNewDocument = this.newDocument.length === 0;
      return noDocument && noNewDocument;
    },
  },
  watch: {
    detailedInfo(data) {
      const { form } = this;
      form.id = data.id;
      form.reg_no = data.reg_no;
      form.metadata.storage_type = data.metadata == null ? null : data.metadata.storage_type;
      form.metadata.working_area = data.metadata == null ? '' : data.metadata.working_area;

      this.isCDD = data.metadata == null ? false : data.metadata.cdd == 1;
      form.metadata.cdd = this.isCDD ? 1 : 0;

      this.isStandby = data.metadata == null ? false : data.metadata.standby == 1;
      form.metadata.standby = this.isStandby ? 1 : 0;
    },
    "form.metadata.standby"(value) {
      if (value == false) {
        value = 0;
      } else {
        value = 1;
      }
    },
    "form.metadata.cdd"(value) {
      if (value == false) {
        value = 0;
      } else {
        value = 1;
      }
    },
    isStandby(value) {
      this.form.metadata.standby = value ? 1 : 0;
    },
    isCDD(value) {
      this.form.metadata.cdd = value ? 1 : 0;
    }
  },
  methods: {
    onCompanySelected(company) {
      if (isObject(company)) {
        this.form.company = company;
      }
    },
    onSubmit() {
      const currentArea = this.working_area.filter(area => area.show)
        .map(area => area.value);
      this.form.metadata.working_area = Object.assign([], currentArea);
      this.metaNew.forEach(val => {
        if (val.value === "") {
          return;
        }
        if (this.form.metadata.working_area.includes(val.value) === false) {
          this.form.metadata.working_area.push(val.value);
        }
      });
      const currentFleetEquipment = this.fleet_equipment.filter(equipment => equipment.show)
        .map(equipment => equipment.value);
      this.form.metadata.fleet_equipment = Object.assign([], currentFleetEquipment);
      this.newFleetEquipment.forEach(equipment => {
        if (equipment.value) {
          const isDuplicate = this.form.metadata.fleet_equipment.find(
            e => e.toString().toLowerCase() === equipment.value.toString().toLowerCase())
          if (!isDuplicate) this.form.metadata.fleet_equipment.push(equipment.value);
        }
      })
      const currentDocument = this.document.filter(d => d.show)
        .map(d => ([d.item, d.date]));
      this.form.metadata.document = Object.assign([], currentDocument);
      this.newDocument.forEach(d => {
        if (d.item) {
          const isDuplicate = this.form.metadata.document.find(
            e => e[0].toString().toLowerCase() === d.item.toString().toLowerCase())
          if (!isDuplicate) this.form.metadata.document.push([ d.item, d.date ]);
        }
      })
      this.validate().then((valid) => {
        if (valid) {
          this.loadingSpinner = true;
          this.beforeClick = false;
          this.disabled = true;
          let { vehicleId } = this.$route.params;
          const { companyId } = this.$route.params;
          const action = this.isEdit ? 'UPDATE_DATA' : 'CREATE_DATA';

          if (!this.isEdit) {
            const namespace = get(this.form, 'company.name', this.form.company.id);
            const regNo = this.form.reg_no.replace(/\W+/g, '');
            this.form.external_id = `${namespace}-${regNo}`;
          }
          this.$store.dispatch(`vehicles/${action}`, this.form).then((vehicle) => {
            if (companyId) {
              this.$router.push(`/admin/companies/${companyId}/vehicles`);
            } else {
              vehicleId = this.isEdit ? vehicleId : vehicle.id;
              this.$router.push(`/admin/vehicles/${vehicleId}`);
            }
          });
        } else {
          this.loadingSpinner = false;
          this.beforeClick = true;
          this.disabled = false;
        }
      });
    },
    validate() {
      return this.$validator.validateAll();
    },
    onCancel() {
      const { vehicleId, companyId } = this.$route.params;
      if (this.isEdit) {
        this.$router.push(`/admin/vehicles/${vehicleId}`);
      } else if (companyId) {
        this.$router.push(`/admin/companies/${companyId}/vehicles`);
      } else {
        this.$router.push('/admin/vehicles');
      }
    },
    addRows() {
      this.metaNew.push({ key: this.metaNew.length + 1, value: '' });
    },
    removeElement(index, newData = false) {
      if (!newData) {
        const area = this.working_area.find(a => a.key === index);
        this.oldToRemove.push(area.value);
      } else {
        this.metaNew = this.metaNew.filter(area => area.key !== index);
      }
    },
    handleChangeWorkingArea(dt) {
      const areaIdx = this.working_area.findIndex(area => area.key === dt.key);
      this.working_area[areaIdx] = dt;
    },
    addFleetEquipment() {
      this.newFleetEquipment.push({ key: this.newFleetEquipment.length + 1, value: '' });
    },
    handleChangeFleetEquipment(fe) {
      const index = this.fleet_equipment.findIndex(equipment => equipment.key === fe.key);
      this.fleet_equipment[index] = fe;
    },
    removeFleetEquipment(index, insert = false) {
      if (insert) {
        this.newFleetEquipment = this.newFleetEquipment.filter(equipment => equipment.key !== index);
      } else {
        const equipment = this.fleet_equipment.find(equipment => equipment.key === index);
        this.removedFleetEquipment.push(equipment.value);
      }
    },
    addDocument() {
      this.newDocument.push({ key: this.newDocument.length + 1, item: '', date: '' });
    },
    handleChangeDocument(fe) {
      const index = this.document.findIndex(equipment => equipment.key === fe.key);
      this.document[index] = fe;
    },
    removeDocument(index, insert = false) {
      if (insert) {
        this.newDocument = this.newDocument.filter(document => document.key !== index);
      } else {
        const document = this.document.find(document => document.key === index);
        this.removedDocument.push(document);
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/pages/admin/vehicles/CreateEdit.vue